import Setting from '@/ecm/models/Setting';
import Role from '@/ecm/models/Role';
import Organization from '@/ecm/models/Organization';
import User from '@/ecm/models/UserImport';
import EmailSettings from '@/ecm/models/EmailSettings';

export default class OrganizationWizard {
    constructor (userDto) {
        this.organization = new Organization();
        this.settings = new Setting();
        this.emailSettings = new EmailSettings();
        this.roles = [];
        this.users = [];
        this.contentTypes = [];

        var adminRole = new Role();
        adminRole.isOrganizationAdmin = true;
        this.roles.push(adminRole);

        var adminUser = new User();
        adminUser.roles.push(adminRole.name);
        this.users.push(adminUser);

        if (userDto) {
            this.settings.defaultDateFormat = userDto.MetricDateFormat;
            this.settings.defaultDecimalSeparator = userDto.MetricDecimalSep;
            this.settings.defaultThousandSeparator = userDto.MetricThousandSep;
            this.settings.defaultLanguageId = userDto.LanguageID + '';
            this.settings.defaultTimezone = userDto.TimeZoneID + '';
        }
    }

    toDto () {
        return {
            OrgData: this.organization.toDto(),
            Settings: this.settings.toDto(),
            EmailSettings: this.emailSettings.toDto(),
            Roles: this.roles.map(function (role) { return role.toDto(); }),
            Users: this.users.map(function (user) { return user.toDto(); }),
            ContentTypes: this.contentTypes.map(function (contentType) { return contentType.toDto(); }),
        };
    }
}
